import { getData } from "./axiosConfig"

export const getTermAndCondition = async () => {
    return await getData("/pages/terms-and-condition")
}

export const getLegalPolicy = async () => {
    return await getData("/pages/legal-policy")
}

export const getPrivacyPolicy = async () => {
    return await getData("/pages/privacy-policy")
}

export const getAboutUs = async () => {
    return await getData("about-us")
}